module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-07-8ce117585d0e1d75c4dba960a1a59b72.svg";